import { render, staticRenderFns } from "./FormComissionBlock.vue?vue&type=template&id=32eefa6e&scoped=true&"
import script from "./FormComissionBlock.vue?vue&type=script&lang=ts&"
export * from "./FormComissionBlock.vue?vue&type=script&lang=ts&"
import style0 from "./FormComissionBlock.vue?vue&type=style&index=0&id=32eefa6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eefa6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
